import React, { CSSProperties } from 'react';

interface IProps {
  style?: CSSProperties;
  fill?: string;

  [prop: string]: unknown;
}

export default ({ style, fill = '#348AEB', ...rest }: IProps) => {
  const defaultStyle = { width: 50, height: 50 };
  const styles = { ...defaultStyle, ...style };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={styles} width={styles.width} height={styles.height}
         viewBox="0 0 50 50" fill="none" {...rest}>
      <path opacity="0.24"
            d="M28.125 42.1875V7.8125C28.125 7.3981 27.9604 7.00067 27.6674 6.70765C27.3743 6.41462 26.9769 6.25 26.5625 6.25H7.8125C7.3981 6.25 7.00067 6.41462 6.70765 6.70765C6.41462 7.00067 6.25 7.3981 6.25 7.8125V42.1875"
            fill={fill} />
      <path d="M3.125 42.1875H46.875" stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M28.125 42.1875V7.8125C28.125 7.3981 27.9604 7.00067 27.6674 6.70765C27.3743 6.41462 26.9769 6.25 26.5625 6.25H7.8125C7.3981 6.25 7.00067 6.41462 6.70765 6.70765C6.41462 7.00067 6.25 7.3981 6.25 7.8125V42.1875"
        stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M43.75 42.1875V20.3125C43.75 19.8981 43.5854 19.5007 43.2924 19.2076C42.9993 18.9146 42.6019 18.75 42.1875 18.75H28.125"
        stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.5 14.0625H18.75" stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.625 26.5625H21.875" stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.5 34.375H18.75" stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M34.375 34.375H37.5" stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M34.375 26.5625H37.5" stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
